import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { InformationCircleContained } from 'blaze-ui/icons'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { useMediaFileProviderData } from 'hooks/queries/mediaFiles/useMediaFileProviderData'
import Styles from './AttributionSummary.module.scss'
import {
  FreepikSummary,
  GettyImagesSummary,
  PexelsSummary,
} from 'components/VisualStudioPlayground/VisualEditor/components/Toolbars/components/MoreOptionsButton/AttributionSummary'
import { FreepikProviderData, GettyImagesProviderData, PexelsProviderData } from 'types'

interface Props {
  mediaFileId: string
}

export const AttributionButton = ({ mediaFileId }: Props) => {
  const { data } = useMediaFileProviderData(mediaFileId)

  if (!data) return null

  const { provider, provider_data } = data

  if (!provider || !provider_data) return null

  return (
    <DropdownTrigger __UNSAFE_popoverStyle={{ width: 250 }}>
      <IconButton
        size="sm"
        variant="editor"
        icon={InformationCircleContained}
        preventFocusOnPress
        aria-label="Attribution"
      />
      {() => (
        <div className={Styles.attributionSummary}>
          {provider === 'gettyimages' && (
            <GettyImagesSummary provider_data={provider_data as GettyImagesProviderData} />
          )}
          {provider === 'freepik' && <FreepikSummary provider_data={provider_data as FreepikProviderData} />}
          {provider === 'pexels' && <PexelsSummary provider_data={provider_data as PexelsProviderData} />}
        </div>
      )}
    </DropdownTrigger>
  )
}
